import { AppMessages } from 'i18n/messages';
import { useLocale } from 'hooks/useLocale/useLocale';
import {
  CardsQueryKeysEnum,
  QueryKeyLocalStorageEnum,
  RandomControlIdSortEnum,
  RandomControlOwnerNameSortEnum,
  RandomControlOwnerRegistrationNumberSortEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { Table } from 'ui/table/Table';
import { OrganizationsTreeSelect } from 'ui/organizationsTreeSelect/OrganizationsTreeSelect';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { ProblemTkdDescriptionEnum } from 'api/cards/cards.enum';

import * as Styled from './RandomControlTableHeader.styles';

export const RandomControlTableHeader = () => {
  const { formatMessage } = useLocale();

  const {
    storedQueries: { [QueryKeyLocalStorageEnum.RANDOM_CONTROL]: randomControlQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const setRandomControlQuery = (updatedOwnersQuery: Partial<typeof randomControlQuery>) => {
    setQuery(QueryKeyLocalStorageEnum.RANDOM_CONTROL, {
      ...randomControlQuery,
      ...updatedOwnersQuery,
    });
  };

  const problemTkdFilterOptions = [
    {
      name: formatMessage({ id: AppMessages[ProblemTkdDescriptionEnum.true] }),
      filterBy: 'true',
    },
    {
      name: formatMessage({ id: AppMessages[ProblemTkdDescriptionEnum.false] }),
      filterBy: 'false',
    },
  ];

  return (
    <>
      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.RANDOM_CONTROL}
        sortBy={RandomControlIdSortEnum}
        queryHeader={formatMessage({ id: AppMessages['control.random.table.id'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.RANDOM_CONTROL}
        sortBy={RandomControlOwnerNameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['control.random.table.name'] })}
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.RANDOM_CONTROL}
        queryName={CardsQueryKeysEnum.PROBLEM_TKD}
        filterItems={problemTkdFilterOptions}
        queryHeader={formatMessage({ id: AppMessages['control.random.table.reader'] })}
        queryHeaderDescriptions={ProblemTkdDescriptionEnum}
        headerWrapper={(header) => <Styled.ProblemTkdHeaderText noWrap>{header}</Styled.ProblemTkdHeaderText>}
      />

      <OrganizationsTreeSelect
        multiple
        isFilterType
        onChange={(options) =>
          options &&
          setRandomControlQuery({
            komorka: options.map((cell) => cell.id),
          })
        }
        value={randomControlQuery.komorka?.map((id) => ({ id, nazwa: 'komorka' }))}
        placeholder={formatMessage({ id: AppMessages['control.random.table.cell'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.RANDOM_CONTROL}
        sortBy={RandomControlOwnerRegistrationNumberSortEnum}
        queryHeader={formatMessage({ id: AppMessages['control.random.table.registrationNumber'] })}
      />
    </>
  );
};
